<template>
    <div id="Gaiptal">
        <div id="icerik">
            <div id="logo">
                <img src="https://static.supsis.live/common/image/betnanoLogo.svg" />
            </div>

            <div id="banner">
                <div class="header-content">
                    <div class="header-text-one">
                        Site kurallarımızda da yazdığı gibi hesabına Google Authenticator uygulamasını kurmayan tüm
                        üyeler hesap güvenliklerini korumak ile yükümlüdür. Kurmayan hiç bir üye, hesabı ile yaşadığı
                        hiç bir problemde hak iddia edemez. İlgili kural Genel Kural ve Şartlar sayfamızda da
                        bulunmaktadır.
                    </div>
                    <!--                    <div class="header-text-two">-->
                    <!--                        Betnano Çözüm 24 saat hizmet vermektedir.-->
                    <!--                    </div>-->
                    <div class="header-text-three">
                        NANO GUARD <br> “GİZLİ ÜYELİK”
                    </div>
                </div>
            </div>
            <div style="margin-top: -30px;" class="content">
                <div class="container-header">
                    <img src="../assets/bgTop.png">
                </div>
                <div id="sari-kutu">
                    <div class="btn-item">
                        <img src="../assets/banner.svg">
                        <span class="btn-text">NANO GUARD NEDİR?</span>
                    </div>
                    <div class="title-nano">
                        "NANO GUARD” <br>
                        tamamıyla üyelerin güvenliğini, gizliliğini ve korunmasını sağlayacak bir sistemdir.
                    </div>
                    <iframe
                        :src="`https://form.supsis.ai/form/66dee5d2ae6cfa5beda21a1d/6423065cd13386cb77688696?username=${username}&fullName=${fullName}&special=true`"
                        width="350px" height="380px" style="border: 0px;margin-top:-20px" id="myIframe"></iframe>
                    <div class="social-media-icon">
                        <div class="left-align" @click="$router.push({ path: '/betnanoLogin' })">
                            <img src="../assets/rightMenu.svg">
                        </div>
                        <div class="center-align">
                            <div>
                                <a href=" https://t.me/Nano_news_turkiye" target="_blank">
                                    <img src="../assets/telegramIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href=" https://x.com/BnanoNewsTR " target="_blank">
                                    <img src="../assets/twitIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://www.youtube.com/@NanoNewsTR" target="_blank">
                                    <img src="../assets/youtubeIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://www.instagram.com/nanonewsturkiye/" target="_blank">
                                    <img src="../assets/instagramIcon.svg">
                                </a>
                            </div>
                            <div>
                                <a href="https://whatsapp.com/channel/0029VbBaCntICVfsp9TNWS40" target="_blank">
                                    <img src="../assets/whatsappIcon.svg">
                                </a>
                            </div>
                        </div>
                        <div class="right-align" @click="goBack">
                            <img src="../assets/leftMenu.svg">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "GaiptalEtme",
    data() {
        return {
            username: "",
            fullName: "",
        };
    },
    mounted() {
        this.username = this.$route.query.username;
        this.fullName = this.$route.query.fullName;
        if (!this.username || this.username === 'undefined' || !this.fullName || this.fullName === 'undefined') {
            this.$router.push({ path: '/betnanoLogin' });
        }
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>

<style lang="scss" scoped>
.title-nano {
    background: linear-gradient(#131313 0%, rgb(44, 44, 44) 50%, #1e1e1e 100%);
    width: 89%;
    margin: auto;
    border-radius: 7px;
    height: 110px;
    text-align: center;
    color: #fbb03a;
    font-weight: bold;
    font-size: 21px;
    padding: 5px;
}

.btn-item {
    position: relative;
    text-align: center;
    cursor: pointer;
}

.btn-item img {
    width: 90%;
}

.btn-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fbb03a;
    font-weight: bold;
    font-size: 21px;
    padding: 30px;
    width: 330px;
}

html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
}

#Gaiptal {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    display: flex;
    background: radial-gradient(circle at center top, #C8A244 10%, black 70%);
}


#icerik {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
}

#logo {
    width: 100%;
    text-align: center;
    margin-top: 0;
    background-color: transparent;
    color: white;
    font-size: 24px;

    img {
        width: 300px;
    }
}

#banner {
    width: 100%;
    height: 200px;
    margin: 20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 20px;

    .header-content {
        width: 100%;
        max-width: 500px;
        height: 220px;
        background-image: url("../assets/header.svg");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;

        .header-text-one {
            color: white;
            font-weight: 900;
            font-size: 14px;
            max-width: 350px;
            text-align: center;
            margin: auto;
            padding: 5px;
        }

        .header-text-two {
            font-weight: 900;
            color: #fdbc14;
            width: 177px;
            margin: auto;
            font-size: 15px;
        }

        .header-text-three {
            font-weight: bold;
            font-family: sans-serif;
            color: black;
            font-size: 25px;
            padding: 28px;
        }
    }
}


.container-wrapper {
    max-width: 500px;
    margin: 0 auto;
}

.container-header {
    border-right: 15px solid #ffd905;
}

.container-header, #sari-kutu {
    max-width: 500px;
}

.container-header img {
    width: 100%;
}

#sari-kutu {
    position: relative;
    background: linear-gradient(92deg, #ffda03, #fcb814);
    margin-top: -7px;
    color: black;
    text-align: center;
    font-size: 18px;
    min-height: 100px;
    margin-bottom: 100px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: 15px solid #ffd905;

    .social-media-icon {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-top: -100px;

        div {
            img {
                width: 30px;
                height: 30px;
                cursor: pointer;
            }
        }
    }

    .left-align {
        flex: 1;
        text-align: left;
        margin-top: -50px;

        img {
            width: 100px !important;
            height: 200px !important;
        }
    }

    .right-align {
        flex: 1;
        text-align: right;
        margin-top: -50px;
        margin-right: -15px;

        img {
            width: 100px !important;
            height: 200px !important;
        }
    }

    .center-align {
        display: flex;
        justify-content: center;
        flex: 2;
    }
}

@media (max-width: 1000px) {
    #Gaiptal {
        display: flex !important;
        flex-direction: column;
        background: radial-gradient(circle at center top, #C8A244 10%, black 30%);
    }
    #banner {
        margin-top: -40px !important;
    }
    .header-content {
        margin-top: 95px;
        height: 150px !important;

        .header-text-one {
            width: 250px !important;
            font-size: 10px !important;
        }

        .header-text-three {
            font-size: 16px !important;
            padding: 14px !important;
        }
    }
    .content {
        margin-top: -15px !important;
        margin-right: 10px;
        margin-left: 10px;

    }

}
</style>

